import {
  FTUE_TARGETS,
  resolveFtueSurfaceLabel,
  resolveFtueTarget,
} from './registry';
import type { FtueTarget } from './types';

export type FtueCatalogHit = FtueTarget & {
  surfaceLabel: string;
  score: number;
};

function normalize(q: string): string[] {
  return q
    .toLowerCase()
    .split(/[^\p{L}\p{N}]+/u)
    .filter(Boolean);
}

/** Simple keyword search over the central help registry. */
export function searchFtueCatalog(query: string): FtueCatalogHit[] {
  const tokens = normalize(query);
  if (!tokens.length) {
    return FTUE_TARGETS.map(t => {
      const resolved = resolveFtueTarget(t);
      return {
        ...resolved,
        surfaceLabel: resolveFtueSurfaceLabel(resolved.surface),
        score: 0,
      };
    });
  }

  const hits: FtueCatalogHit[] = [];
  for (const raw of FTUE_TARGETS) {
    const t = resolveFtueTarget(raw);
    const hay = [
      t.title,
      t.body,
      t.id,
      resolveFtueSurfaceLabel(t.surface),
      ...(t.keywords ?? []),
      ...t.actions,
      t.catalogNote ?? '',
    ]
      .join(' ')
      .toLowerCase();
    let score = 0;
    for (const tok of tokens) {
      if (t.title.toLowerCase().includes(tok)) score += 5;
      else if (t.keywords.some(k => k.toLowerCase().includes(tok))) score += 3;
      else if (hay.includes(tok)) score += 1;
      else {
        score = -1;
        break;
      }
    }
    if (score >= 0) {
      hits.push({
        ...t,
        surfaceLabel: resolveFtueSurfaceLabel(t.surface),
        score,
      });
    }
  }
  hits.sort((a, b) => b.score - a.score || a.title.localeCompare(b.title));
  return hits;
}
